import React from "react";
import SEO from "../../../hooks/SEO";
import Service from "../Service";
import { serviceDetails, siteMeta } from "../../../data/mockData";

const Petrol = () => (
  <>
    <SEO
      title={`${serviceDetails["petroleum-services"].title} | Refwa`}
      description={serviceDetails["petroleum-services"].intro}
      name={siteMeta.name}
      type="website"
    />
    <Service service={serviceDetails["petroleum-services"]} />
  </>
);

export default Petrol;
